export default {"src":"https://s.sylndr.me/c-a7be377/_next/static/media/carGreenIcon.9e5e7f05.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};